import React, { useState, useEffect } from 'react';
import ItemSelector from "../../../../../components/controls/itemSelector.jsx";

export default function FieldsFilterResults({ dataRule, filterFieldsResultList, ruleChanged }) {
    const [items, setItems] = useState([]);

    useEffect(() => mountProperties(), [dataRule, filterFieldsResultList]);

    return <div className="dm-container dm-no-padding">
        <ItemSelector
            items={items}
            selectedItemsChanged={selectedItemsChanged} />
    </div>;

    function mountProperties() {
        if (!dataRule) {
            setItems([]);
            return;
        }

        let itemsLocal = Array.isArray(filterFieldsResultList) && filterFieldsResultList.length ? filterFieldsResultList : [];
        itemsLocal.forEach(i => i.isSelected = dataRule.filterResult.some(id => id == i.id));

        setItems(itemsLocal);
    }

    function selectedItemsChanged(selectedItems) {
        if (ruleChanged)
            ruleChanged({
                ...dataRule,
                filterResult: selectedItems ? selectedItems.map(i => i.id) : [],
                isUpdated: true
            });
    }
}